var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var configuredTenantNames = function (okapiTenant, tenantOptions) {
    var names = Object.values(tenantOptions !== null && tenantOptions !== void 0 ? tenantOptions : {}).map(function (option) { return option.name; });
    return okapiTenant ? __spreadArray([okapiTenant], names, true) : names;
};
export var readStoredTenant = function (raw, allowedNames) {
    if (!raw) {
        return undefined;
    }
    try {
        var parsed = JSON.parse(raw);
        return typeof (parsed === null || parsed === void 0 ? void 0 : parsed.tenantName) === "string" && allowedNames.includes(parsed.tenantName)
            ? parsed
            : undefined;
    }
    catch (_a) {
        return undefined;
    }
};
